<template>
  <div :class="['com-links', className]">
    <a v-for="(item, index) in list" :key="index" class="com-link" :href="resolveLink(item.url)">
      {{ item.name }}
    </a>
  </div>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'

interface LinkConfig {
  name: string
  url: string
}

const { app } = useRuntimeConfig()
const resolveLink = (url: string) => {
  if (!url || /^(?:[a-z][a-z\d+.-]*:|\/\/|#)/i.test(url)) return url

  const baseURL = app.baseURL || '/'
  if (url === baseURL || url.startsWith(baseURL)) return url

  return `${baseURL.replace(/\/$/, '')}/${url.replace(/^\/+/, '')}`
}

defineProps({
  list: {
    type: Array as PropType<LinkConfig[]>,
    default: () => [] as LinkConfig[]
  },
  className: null as unknown as PropType<unknown>
})
</script>
<style lang="scss" scoped>
.com-links {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  color: #ededed;
}
.com-link {
  float: left;
  position: relative;
  pointer-events: auto;

  &:after {
    content: '';
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 100%;
    height: 1px;
    opacity: 0.9;
    background-color: #ededed;
  }
}
@media not all and (min-width: 1024px) {
  .com-links {
    justify-content: center;
    text-align: left;
    font-size: 24px;
    margin-right: auto;
    width: 100%;
  }
  .com-link {
    margin: 0 12px;
  }
}
@media screen and (min-width: 1024px) {
  .com-link {
    margin: 0 30px 0 0;

    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
